/**
 * Contains functions commonly used in different js files
 */
class AssessmentHelper {
    public isCorrectAnswer(): boolean {
        const $form = $('.sl-js-survey-page-form');
        const $answerList = $form.find('.js-answer-list');
        const selectedAnswer = $form.find('.js-sctn-response-list input:checked').val();
        const correctAnswer = $answerList.data('correct-answer');

        return correctAnswer == selectedAnswer;
    };
}

export default new AssessmentHelper();
